export default "__VITE_ASSET__BE$tmjjO__"